import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Bar } from 'vue-chartjs';

// @ts-ignore
@Component({})
export default class VerticalBarChart extends Mixins(Bar) {
  @Prop({ default: null })
  private barChartData!: any | null;
  @Prop({ default: null })
  private barChartOptions!: any | null;

  public mounted() {
    const showZeroPlugin = {
      beforeRender(chartInstance: any) {
        const dataSets = chartInstance.config.data.datasets;
        for (const [dataSetIndex] of dataSets.entries()) {
          const meta = dataSets[dataSetIndex]._meta;
          const metaData = meta[Object.keys(meta)[0]];
          const bars = metaData.data;
          for (const [barIndex] of bars.entries()) {
            const model = bars[barIndex]._model;
            if (model.base === model.y) {
              model.y = model.base - 2;
            } else if (model.base < model.y) {
              model.backgroundColor = 'transparent';
              model.borderWidth = '1';
              model.y = model.base - 1;
            }
          }
        }
      },
    };
    const dashBarPlugin = {
      afterDatasetDraw(chart: any, args: any) {
        args.meta.data.forEach((element: any) => {
          if (element._model.base - element._model.y < 0) {
            const borderWidth = 8;
            const ctx = chart.ctx;
            const vm = element._view;
            const half = vm.width / 2;
            const left = vm.x - half;
            const right = vm.x + half;
            const top = vm.y - 2;
            const width = right - left;
            const height = chart.chartArea.bottom - top + borderWidth / 2 - 1;
            ctx.beginPath();
            ctx.lineWidth = borderWidth;
            ctx.strokeStyle = '#000000';
            ctx.setLineDash([3, 4]);
            ctx.moveTo(left, top);
            ctx.lineTo(left, top + height);
            ctx.moveTo(left, top);
            ctx.lineTo(left + width, top);
            ctx.moveTo(left + width, top);
            ctx.lineTo(left + width, top + height);
            ctx.stroke();
            ctx.save();
          }
        });
      },
    };
    if (this.barChartData) {
      // Uncomment next line to show bar for 0 values
      // this.addPlugin(showZeroPlugin);
      this.addPlugin(dashBarPlugin);
      this.renderChart(this.barChartData, this.barChartOptions);
    }
  }
}
